export const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
export const FONT_FAMILY_MONO =
  '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
export const AKTIV_FONT_FAMILY =
  '"Aktiv Grotesk", "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
export const FONT_SIZE = 13
export const GLOBAL_FONT_SIZE_NAMESPACE = '--HSDSGlobalFontSize'
export const BASE_FONT_SIZE = FONT_SIZE
export const defaultProps = {
  baseFontSize: BASE_FONT_SIZE,
  fontSize: BASE_FONT_SIZE,
}
